import script from "./StepProofAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./StepProofAddress.vue?vue&type=script&setup=true&lang=js"

import "./StepProofAddress.vue?vue&type=style&index=0&id=09e03634&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09e03634"]])

export default __exports__